export const EXPENSE_CATEGORIES = [
  { value: "FOOD_PURCHASES", label: "Food purchases" },
  { value: "STATIONERY", label: "Stationery" },
  { value: "FUEL", label: "Fuel" },
  { value: "CLEANING", label: "Cleaning supplies" },
  { value: "MAINTENANCE", label: "Repairs & maintenance" },
  { value: "EQUIPMENT", label: "Equipment" },
  { value: "PACKAGING", label: "Packaging" },
  { value: "PETTY_CASH", label: "Petty cash" },
  { value: "CARD_PURCHASE", label: "Card purchase" },
  { value: "OTHER", label: "Other" },
];

export const EXPENSE_CAT_LABEL = Object.fromEntries(
  EXPENSE_CATEGORIES.map((c) => [c.value, c.label])
);
